import Vue from "vue";

export const ParentFormState = {
  parentForm: null,
  parentFormSections: [],
  prospectForm: null,
  prospectFormAnswers: []
};

export const ParentFormGetters = {
  parentForm: state => {
    return state.parentForm;
  },
  parentFormSections: state => {
    return state.parentFormSections;
  },
  prospectForm: state => {
    return state.prospectForm;
  },
  prospectFormAnswers: state => {
    return state.prospectFormAnswers;
  }
};

export const ParentFormMutations = {
  setParentForm: (state, data) => {
    Vue.set(state, "parentForm", data);
    Vue.set(state, "parentFormSections", data.sections);
    Vue.set(state, "prospectFormAnswers", []);
  },
  setParentFormSections: (state, data) => {
    Vue.set(state, "parentFormSections", data);
  },
  setParentFormSection: (state, data) => {
    const index = state.parentFormSections.findIndex(
      i => Number(i.id) === Number(data.id)
    );
    if (index > -1) {
      const arr = [...state.parentFormSections];
      arr[index].name = data.name;
      Vue.set(state, "parentFormSections", arr);
    }
  },
  //
  setProspectForm: (state, data) => {
    Vue.set(state, "prospectForm", data);
    Vue.set(state, "prospectFormAnswers", []);
  },
  addProspectForm: (state, data) => {
    // prospectInformation sales-pipeline.store.js
    const item = { ...state.prospectInformation };
    Vue.set(state, "prospectInformation", { ...item, current_form: data });
  },
  setProspectFormAnswers: (state, data) => {
    Vue.set(state, "prospectFormAnswers", data);
  },
  setProspectFormAnswer: (state, data) => {
    const index = state.prospectFormAnswers.findIndex(
      i => Number(i.question_id) === Number(data.question_id)
    );
    if (index > -1) {
      let arr = [...state.prospectFormAnswers];
      if (!data.answer) {
        arr = arr.filter(
          i => Number(i.question_id) !== Number(data.question_id)
        );
      } else arr[index] = data;
      Vue.set(state, "prospectFormAnswers", arr);
    } else {
      const arr = [...state.prospectFormAnswers, data];
      Vue.set(state, "prospectFormAnswers", arr);
    }
  }
};

export const ParentFormActions = {
  getParentForm: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/parent_form`)
      .then(response => {
        commit("setParentForm", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch parent form from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateParentForm: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/forms/${data.id}`, { form: data.form })
      .then(response => {
        commit("setParentForm", response.data);
        const title = `Parent form updated`;
        const message = `Success! The parent form has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update parent form.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createParentFormSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/forms/${data.form_id}/form_sections`, {
        section: data.section
      })
      .then(response => {
        dispatch("getParentForm");
        const title = `New form section added`;
        const message = `Success! New form section has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create form section.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateParentFormSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/form_sections/${data.id}`, { section: data.section })
      .then(response => {
        dispatch("getParentForm");
        const title = `Form section updated`;
        const message = `Success! The form section has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update form section.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteParentFormSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/form_sections/${data.id}`)
      .then(response => {
        dispatch("getParentForm");
        const title = `Form section deleted`;
        const message = `Success! The form section has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete form section.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  updateParentFormQestion: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/questions/${data.id}`, { question: data.question })
      .then(response => {
        // dispatch("getParentForm");
        commit("setParentForm", response.data);
        const title = `Form question updated`;
        const message = `Success! The form question has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update form question.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  generateProspectFormLink: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/prospects/${data.prospect_id}/generate_parent_form`)
      .then(response => {
        commit("addProspectForm", response.data);
        // const title = `Prospect form link generated`;
        // const message = `Success! New prospect form link has been generated.`;
        // dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create prospect form link.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getProspectForm: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/prospect_forms/${data.slug}`)
      .then(response => {
        commit("setProspectForm", response.data.prospect_form);
        const sections = [...response.data.form];
        commit("setParentFormSections", sections);
        let answer = [];
        sections.forEach(section => {
          section.questions.forEach(question => {
            if (question.default_value) {
              answer.push({
                section_id: section.id,
                question_id: question.id,
                answer: question.default_value
              });
            }
          });
        });
        commit("setProspectFormAnswers", answer);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch parent form from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateProspectAnswer: ({ commit }, data = {}) => {
    return commit("setProspectFormAnswer", data);
  },
  deleteProspectAnswer: ({ commit }, data = {}) => {
    return commit("setProspectFormAnswer", data);
  },
  submitProspectForm: ({ state, commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/prospect_forms//${data.slug}/submit`, {
        prospect_form: { answers: state.prospectFormAnswers }
      })
      .then(response => {
        commit("setProspectForm", response.data);
        const title = `Prospect form submitted`;
        const message = `Success! The prospect form has been submitted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to submitted form prospect form.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/parent-form.store.js